// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"a9e0a36f","498":"e995fb30","703":"e44f17ff"}[chunkId] + ".chunk.js";
};